import { Box } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import moment from "jalali-moment";

// updated
export default function AppTimePicker(props: {
    onChange: (date: string | null) => void;
    initialValue?: string;
    label?: string;
}) {
    const onDateChange = (date: Date | null) => {
        if (!date) {
            props.onChange(null);
        } else {
            props.onChange(moment(date).toJSON());
        }
    };

    return (
        <Box sx={{ width: "100%" }}>
            <DateTimePicker
                sx={{ width: "100%" }}
                dayOfWeekFormatter={(d) => {
                    switch (d) {
                        case "ش":
                            return "ش";
                        case "1ش":
                            return "ی";
                        case "2ش":
                            return "د";
                        case "3ش":
                            return "س";
                        case "4ش":
                            return "چ";
                        case "5ش":
                            return "پ";
                        case "ج":
                            return "ج";
                    }
                    return "";
                }}
                label={props.label}
                onChange={onDateChange}
                value={
                    props.initialValue
                        ? moment(props.initialValue).toDate()
                        : undefined
                }
            />
        </Box>
    );
}
